export default __webpack_public_path__ + "static/media/1.019a8306.jpg";